import React from 'react'
import s from './styles/HeaderDashboard.module.scss'
import NotificationDropdown from 'widgets/NotificationDropdown/NotificationDropdown'
import { observer } from 'mobx-react-lite'
import { useStudentSearch } from 'shared/hooks/useStudentSearch'
import { useIsMobile } from 'shared/hooks/useBreakpoint'
import useHeaderMobileSearch from 'widgets/Header/hooks/useHeaderMobileSearch'
import HeaderSearchBlock from 'widgets/Header/components/HeaderSearchBlock/HeaderSearchBlock'
import HeaderSearchToggle from 'widgets/Header/components/HeaderSearchToggle/HeaderSearchToggle'
import HeaderSettingsButton from 'widgets/Header/components/HeaderSettingsButton/HeaderSettingsButton'
import NoteTakerHeaderAction from 'widgets/NoteTaker/NoteTakerHeaderAction'

const HeaderDashboard = observer(() => {
	const isMobile = useIsMobile()
	const { searchExpanded, toggleSearch, collapseSearch } =
		useHeaderMobileSearch()
	const {
		query,
		isOpen,
		isLoading,
		results,
		containerRef,
		handleChange,
		handleFocus,
		handleSelectStudent,
	} = useStudentSearch()

	const showMobileSearchPanel = isMobile && searchExpanded

	return (
		<header className={s.header}>
			<div className={s.wrap}>
				<div className={s.leadingSlot}>
					<span className={s.title}>Dashboard</span>
				</div>

				<div
					className={`${s.searchSlot} ${
						showMobileSearchPanel ? s.searchSlot_expanded : ''
					}`}
				>
					<HeaderSearchBlock
						containerRef={containerRef}
						query={query}
						onSearchChange={handleChange}
						onFocus={handleFocus}
						isOpen={isOpen}
						isLoading={isLoading}
						results={results}
						onSelectStudent={handleSelectStudent}
						showClear={showMobileSearchPanel}
						onClear={collapseSearch}
					/>
				</div>

				<div className={s.actionsSlot}>
					<div className={s.actions}>
						<NoteTakerHeaderAction />
						<HeaderSearchToggle
							onClick={toggleSearch}
							isActive={searchExpanded}
						/>
						<HeaderSettingsButton />
						<NotificationDropdown compact={isMobile} />
					</div>
				</div>
			</div>
		</header>
	)
})

export default HeaderDashboard
